/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AUTHENTICATION_SCOPES } from '@playbookux/playbook-web-core';
import NotFound from '../../pages/not-found';
import { SentryRoute } from '../sentry-route';

const PrivateRoute = (props) => {
  const {
    active = null,
    component: Component,
    isAuthenticated,
    scopes,
    scope,
    isPreview,
    isInvite,
    location,
    ...rest
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);

    if (typeof window.Intercom === 'function') {
      window.Intercom('update');
    }
  }, [location]);

  return (
    <SentryRoute
      {...rest}
      render={(prop) => {
        if (isInvite) {
          return (
            <Component active={active} isPreview={isPreview} {...prop} />
          );
        }
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/sign-in',
                state: { from: prop.location },
              }}
            />
          );
        }

        if (!_.includes(scopes, scope)) {
          return <NotFound {...prop} />;
        }

        return <Component active={active} isPreview={isPreview} {...prop} />;
      }}
    />
  );
};

PrivateRoute.defaultProps = {
  active: null,
  scope: null,
  scopes: [AUTHENTICATION_SCOPES.USER, AUTHENTICATION_SCOPES.TESTER],
  isPreview: false,
  isInvite: false,
};

PrivateRoute.propTypes = {
  isInvite: PropTypes.bool,
  active: PropTypes.string,
  component: PropTypes.elementType.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.shape().isRequired,
  scopes: PropTypes.arrayOf(PropTypes.string),
  scope: PropTypes.string,
  isPreview: PropTypes.bool,
};

const mapStateToProps = ({ authentication }) => ({
  isAuthenticated: authentication.isAuthenticated,
  scope: authentication.scope,
});

export default connect(mapStateToProps, null)(PrivateRoute);
